// extracted by mini-css-extract-plugin
export default {"Expired":"AccreditationDocuments_Expired__s5f36"};